import { render } from "./App.vue?vue&type=template&id=6566d630&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6566d630&scoped=true&lang=scss"

import exportComponent from "/Users/kevinelshout/Projects/Frontend/nopal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6566d630"]])

export default __exports__